/**
 * Safely parses JSON from a Response object with proper error handling
 * for cases where the response might be undefined or invalid.
 */
export async function safeResponseJson<T = any>(
  response: Response | undefined,
): Promise<T | null> {
  try {
    // Check if response exists and has the json method
    if (!response || typeof response.json !== 'function') {
      return null;
    }

    const data = await response.json();

    return data;
  } catch (error) {
    // Silent failure - let calling code handle the null return
    return null;
  }
}

/**
 * Safely handles fetch requests with built-in response validation
 */
export async function safeFetch<T = any>(
  url: string,
  options?: RequestInit,
): Promise<T | null> {
  try {
    const response = await fetch(url, options);
    // If response has ok property and it's false, return null
    if ('ok' in response && !response.ok) {
      return null;
    }

    return safeResponseJson<T>(response);
  } catch (error) {
    return null;
  }
}
